import { createTheme } from '@mui/material'
import muiTooltipTheme from './components/MuiTooltip'

const muiTheme = createTheme({
  components: {
    MuiTooltip: muiTooltipTheme
  }
})

export default muiTheme
